// ABOUTME: Resolves a decoded sidepanel descriptor into the component + props to render.
// ABOUTME: Returns null when the descriptor is missing or its key is not in the registry.

import { sidepanelRegistry } from './sidepanelRegistry';

// decoded: output of decodeSidepanel (already-parsed object) or null
export const resolveSidepanel = (decoded) => {
    if (!decoded) return null;
    const entry = sidepanelRegistry[decoded.k];
    if (!entry) return null;

    const props = { [entry.idProp]: decoded.id };
    const tab = decoded.tab !== null && decoded.tab !== undefined ? decoded.tab : entry.defaultTab;
    if (tab !== null && tab !== undefined) {
        props.defaultTab = tab; // only SpOrderDetails reads defaultTab today; harmless elsewhere
    }
    return { Component: entry.Component, props };
};
